/**
 * TanStack Query hook for GET /api/v1/admin/security/stats.
 *
 * Refetches every 60s by default so the stat cards on AdminSecurityPage
 * stay roughly fresh without hammering the API. Pass refetchInterval=false
 * to disable.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type { SecurityStatsResponse } from "@/types/api";

export const ADMIN_SECURITY_STATS_KEY = ["admin", "security", "stats"] as const;

export interface UseAdminSecurityStatsArgs {
  refetchInterval?: number | false;
  enabled?: boolean;
}

export function useAdminSecurityStats(
  args: UseAdminSecurityStatsArgs = {},
): UseQueryResult<SecurityStatsResponse> {
  const { refetchInterval = 60_000, enabled = true } = args;
  return useQuery({
    queryKey: ADMIN_SECURITY_STATS_KEY,
    queryFn: async () => {
      const response = await api.get<SecurityStatsResponse>(
        "/admin/security/stats",
      );
      return response.data;
    },
    refetchInterval,
    enabled,
  });
}
